import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M57.57 107.8c28.167 0 51-22.834 51-51 0-28.167-22.833-51-51-51s-51 22.833-51 51c0 28.166 22.833 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M86.6 23.77c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      d="M60.5 17.77a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.57 93.53a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="m28.1 100.59 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM98.67 94.09H93.1v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#0597A3"
      d="M18.59 34H97.4c.88 0 1.6.72 1.6 1.6v44.81c0 .88-.71 1.59-1.59 1.59H18.6c-.88 0-1.6-.72-1.6-1.6V35.59c0-.88.71-1.59 1.59-1.59"
    />
    <path
      fill="#00D8D8"
      d="M72.38 28H43.62A1.62 1.62 0 0 0 42 29.62v56.76c0 .895.725 1.62 1.62 1.62h28.76A1.62 1.62 0 0 0 74 86.38V29.62A1.62 1.62 0 0 0 72.38 28"
    />
    <path
      fill="#001A43"
      d="M67 42.23H49c-1.23 0-2.23-1-2.23-2.23s1-2.23 2.23-2.23h18c1.23 0 2.23 1 2.23 2.23s-1 2.23-2.23 2.23M67 54.23H49c-1.23 0-2.23-1-2.23-2.23s1-2.23 2.23-2.23h18c1.23 0 2.23 1 2.23 2.23s-1 2.23-2.23 2.23M67 66.23H49c-1.23 0-2.23-1-2.23-2.23s1-2.23 2.23-2.23h18c1.23 0 2.23 1 2.23 2.23s-1 2.23-2.23 2.23M63.12 78.23H49c-1.23 0-2.23-1-2.23-2.23s1-2.23 2.23-2.23h14.12c1.23 0 2.23 1 2.23 2.23s-1 2.23-2.23 2.23"
    />
  </svg>
);
const SvgEnrichedIconSubscriptionsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSubscriptionsInverted);
export default Memo;
